export const UPDATE_PROFILE_RULE = 'updateProfileRule'
export const UPDATE_GROUP_RULE = 'updateGroupRule'
export const UPDATE_CATEGORY_RULE = 'updateCategoryRule'
export const UPDATE_INTEREST_RULE = 'updateInterestRule'
export const UPDATE_RULE_TYPE_BY_INDEX = 'updateRuleTypeByIndex'
export const UPDATE_RULE_NAME_BY_INDEX = 'updateRuleNameByIndex'
export const UPDATE_REPEATED_BY_INDEX = 'updateRepeatedByIndex'
export const UPDATE_APPLY_TO_NEW_BY_INDEX = 'updateApplyToNewByIndex'
export const UPDATE_FREQUENCY_BY_INDEX = 'updateFrequencyByIndex'
export const UPDATE_SKIP_CONTACTED_WITHIN_BY_INDEX = 'updateSkipContactedWithinByIndex'
export const UPDATE_REMIND_DAYS_BY_INDEX = 'updateRemindDaysByIndex'
export const UPDATE_APPLY_TO_BIRTHDAY_BY_INDEX = 'updateApplyToBirthdayByIndex'
export const UPDATE_APPLY_TO_ALL_BY_INDEX = 'updateApplyToAllByIndex'
export const UPDATE_SCHEDULED_DATE_TIME_BY_INDEX = 'updateScheduledDteTimeByIndex'
export const UPDATE_RULE_MESSAGE_BY_INDEX = 'updateRuleMessageByIndex'
export const UPDATE_TIME_ZONE_BY_INDEX = 'updateTimeZoneByIndex'
export const DELETE_RULE_MESSAGE = 'deleteRuleMessage'
export const ADD_RULE_MESSAGE = 'addRuleMessage'
